import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { OnInit } from '@angular/core';
import { DxValidationGroupComponent } from 'devextreme-angular/ui/validation-group';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth.service';
import { AppInfoService } from '../../services/app-info.service';
import { SAMLService } from '../../services/saml.service';
import { BuildingBlocksService } from '../../services/building-blocks.service';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
    @ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent;

    isLoginEnabled: boolean = true;
    login = '';
    password = '';
    companyName = '';
    showCompany = false;
    subdomain = '';
    isLoginError = false;
    selectedIndex = 1;
    companyLogo = '';

    constructor(private authService: AuthService,
        private router: Router,
        private toast: ToastrService,
        private samlService: SAMLService,
        public appInfo: AppInfoService,
        public bbService: BuildingBlocksService) {

        if (authService.isUserValid()) {
            this.router.navigate(['/home']);
        } else {
            this.authService.removeToken();
        }
        this.setSubdomain();
    }

    ngOnInit() {
        // Remove existing site theme classes so that login form appears with white background always
        Array.from(document.body.classList).forEach(className => {
            if (className.toString().startsWith('dx-swatch') || className === 'core-dark-mode') {
                document.body.classList.remove(className);
            }
        });
    }

    validateGroup() {
        return this.validationGroup.instance.validate();
    }

    showErrorMessage(msg) {
        if (msg == null) {
            msg = 'Login Credentials Invalid';
        }
        if (msg instanceof ProgressEvent){
            msg = 'Server Is Unavailable';
        }
        this.isLoginError = true;
        this.toast.error(msg);
    }

    setSubdomain() {
        const subdomain = this.appInfo.getSubdomain(window.location.hostname);
        if (subdomain) {
            this.subdomain = subdomain.split('.')[0];
            this.companyName = this.subdomain;
            this.showCompany = false;
            this.isUsingSPSSO(this.subdomain);
        } else {
            this.subdomain = '';
            this.companyName = localStorage['companyName'] ?? this.subdomain;
            this.showCompany = true;
        }
    }

    async onLoginClick() {
        this.isLoginEnabled = false;
        if (!this.validateGroup().isValid) {
            this.isLoginEnabled = true;
            return;
        }

        const user = JSON.stringify({ username: this.login, password: this.password, companyName: this.companyName });
        const dest = this.authService.destination ?? '/home';

        await this.authService.login(user)
            .subscribe(result => {
                const loginResponse = result.body;
                let success = 'Successful Login';
                const msg = loginResponse.message;
                if (msg) {
                    success = success.concat('.\n\n').concat(msg);
                }
                this.authService.setLocalStorageAfterLogin();

                if (loginResponse.passwordExpired) {
                    this.toast.error('Your Password Has Expired, Please choose a new password');
                    this.router.navigate(['/change-password']);
                    this.authService.removeToken();
                    this.isLoginEnabled = true;
                } else {
                    this.toast.success(success);
                    this.authService.setToken(loginResponse.token);
                    this.bbService.resetBuildingBlockService().subscribe();
                    this.router.navigate([dest]);
                }
            }, error => {
                this.showErrorMessage(error.error);
                this.isLoginEnabled = true;
            });

    }

    onSsoClick(){
        window.location.href = 'https://' + window.location.hostname + '/initiatesso';
        // window.location.href = 'http://' + window.location.hostname + ':44378/initiatesso'; // Uncomment for local testing
    }

    changeToLogin(){
        this.selectedIndex = 1;
    }

    changeToSso(){
        this.selectedIndex = 0;
    }

    isUsingSPSSO(tenantName: string){
        this.samlService.getIsUsingSPSSO(tenantName).subscribe(result => {
            if (result){
                this.changeToSso();
            }
        });
    }
}
